import { ComponentUsageError } from 'BomdisoftComponents/errors/index';
import { Html } from 'BomdisoftComponents/html/html';

export { Html } from 'BomdisoftComponents/html/html';

export type HtmlValue = Html | string | number | bigint | boolean | null | undefined | readonly HtmlValue[];

export type AttributeValue = string | number | boolean | null | undefined;

const ESCAPED: Readonly<Record<string, string>> = { "'": '&#39;', '"': '&quot;', '&': '&amp;', '<': '&lt;', '>': '&gt;' };

const MARKUP_CHARACTER = /[&<>"']/g;

const ATTRIBUTE_NAME = /^[a-zA-Z_:][-a-zA-Z0-9_:.]*$/;

export const escapeHtml = (text: string) => text.replace(MARKUP_CHARACTER, character => ESCAPED[character] ?? character);

const toMarkup = (value: HtmlValue): string => {
  if (value instanceof Html) return value.value;
  if (Array.isArray(value)) return value.map(toMarkup).join('');
  if (value === null || value === undefined || typeof value === 'boolean') return '';
  return escapeHtml(String(value));
};

export const html = (strings: TemplateStringsArray, ...values: readonly HtmlValue[]) => new Html(strings.reduce((markup, chunk, index) => markup + chunk + (index < values.length ? toMarkup(values[index]) : ''), ''));

const toAttribute = ([name, value]: readonly [string, AttributeValue]) => {
  if (!ATTRIBUTE_NAME.test(name)) throw new ComponentUsageError('invalid_attribute_name', `Invalid attribute name: ${JSON.stringify(name)}`);
  if (value === null || value === undefined || value === false) return '';
  return value === true ? ` ${name}=""` : ` ${name}="${escapeHtml(String(value))}"`;
};

export const attributes = (record: Readonly<Record<string, AttributeValue>>) => new Html(Object.entries(record).map(toAttribute).join(''));

export const joinClasses = (...names: readonly (string | false | null | undefined)[]) => names.filter(name => typeof name === 'string' && name !== '').join(' ');
